@if (!icon()) {
  <div
    class="w-[13px] h-[13px] rounded-[10px]"
    [ngClass]="{
      'bg-status-success': status() === StatusViewModelEnum.Success,
      'drop-shadow-status-success-shadow-30': status() === StatusViewModelEnum.Success,
      'bg-status-warning': status() === StatusViewModelEnum.Warning,
      'drop-shadow-status-warning-shadow-30': status() === StatusViewModelEnum.Warning,
      'bg-foreground-primary-60': status() === StatusViewModelEnum.Disabled,
      'drop-shadow-foreground-primary-60-shadow-30': status() === StatusViewModelEnum.Disabled,
      'bg-status-error': status() === StatusViewModelEnum.Error,
      'drop-shadow-status-error-shadow-30': status() === StatusViewModelEnum.Error,
    }"
  ></div>
}

@if (icon(); as icon) {
  <svg-icon
    [key]="icon"
    size="16"
    [ngClass]="{
      'text-status-success': status() === StatusViewModelEnum.Success,
      'drop-shadow-status-success-shadow-30': status() === StatusViewModelEnum.Success,
      'text-status-warning': status() === StatusViewModelEnum.Warning,
      'drop-shadow-status-warning-shadow-30': status() === StatusViewModelEnum.Warning,
      'text-foreground-primary-60': status() === StatusViewModelEnum.Disabled,
      'drop-shadow-foreground-primary-60-shadow-30': status() === StatusViewModelEnum.Disabled,
      'text-status-error': status() === StatusViewModelEnum.Error,
      'drop-shadow-status-error-shadow-30': status() === StatusViewModelEnum.Error,
    }"
  ></svg-icon>
}

@if (value() | isDefined) {
  <div
    class="text-base font-semibold"
    [ngClass]="{
      'text-base-text': status() === StatusViewModelEnum.Success,
      'text-status-warning': status() === StatusViewModelEnum.Warning,
      'text-status-disabled': status() === StatusViewModelEnum.Disabled,
      'text-status-error': status() === StatusViewModelEnum.Error,
    }"
  >
    {{ value() }}
  </div>
}

@if (acrossSiteCount(); as acrossSiteCount) {
  <span class="translate-y-[1px] text-[11px] leading-[16px] text-foreground-primary-60">
    @if (acrossSiteCount === 1) {
      {{ 'common.across-site' | translate }}
    } @else {
      {{ 'common.across-x-sites' | translate: { count: acrossSiteCount } }}
    }
  </span>
}
